import { State, Action, StateContext } from '@ngxs/store';

import { tap, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';;
import { WorkSplitAction,
        WorkSplitFailAction,
        WorkSplitSuccessAction,
        WorkUnSplitAction,
        WorkUnSplitFailAction,
        WorkUnSplitSuccessAction } from './work-split.actions';
import { TourModel, WorkSplitClient } from '@core/services/api.service';

export class WorkSplitStateModel {
  public isLoading: boolean;
  public showSpinner: boolean;
  public tours: TourModel[];
  public tourId: number;
  public id: number;
}

@State<WorkSplitStateModel>({
  name: 'WorkSplit',
  defaults: {
    isLoading: true,
    tours: [],
    tourId: 0,
    id: 0,
    showSpinner: false,

  }
})

@Injectable()
export class WorkSplitState {
  constructor(private workSplitService: WorkSplitClient) { }

  @Action(WorkSplitAction)
  WorkSplitAction({ dispatch, patchState }: StateContext<WorkSplitStateModel>, action: WorkSplitAction) {
    patchState({ isLoading: true });

    return this.workSplitService.workSplit(action.userId, action.category).pipe(
      tap((tour) => {
        dispatch(new WorkSplitSuccessAction({ tour }));
      }),
      catchError(error => {
        dispatch(new WorkSplitFailAction());
        throw error;
      })
    );
  }

  @Action(WorkUnSplitAction)
  WorkUnSplitAction({ dispatch, patchState }: StateContext<WorkSplitStateModel>, action: WorkUnSplitAction) {
    patchState({ isLoading: true });

    return this.workSplitService.workUnSplit().pipe(
      tap((tour) => {
        dispatch(new WorkUnSplitSuccessAction({ tour }));
      }),
      catchError(error => {
        dispatch(new WorkUnSplitFailAction());
        throw error;
      })
    );
  }

}
